<div *ngIf="dataLoaded | async"
     [ngClass]="{'source-gather': source == 'gather', 'source-mat': source !== 'gather'}">

  <div class='row availability interested-container'>
    <div *ngIf="source=='gather'" class="small-11 small-centered medium-8 large-7 columns">
      <a (click)="backToPosting()"
        class="aquent-orange">
        {{'gather.back-to-posting' | translate}}
      </a>
    </div>

    <section class="grid-y" class="main-container" aria-label="Preinterview Answers Section">

      <form [formGroup]="formGroup" class="form-container">
        <div class="grid-y grid-padding-y">
          <h6 class="cell">
            {{'pre-interview-questions.answer-header-description' | translate}}
          </h6>
          <ng-container *ngFor="let question of questionsForPosting">
            <div class="cell small-12 medium-8" *ngIf="question.questionTypeId === QuestionType.MULTIPLE_CHOICE">
              <div class="cell small-12 medium-12 large-12 question-label">
                <label [ngClass]="{'question-label': source == 'gather'}" class="dropdown-label" attr.aria-label="{{question.questionKey | translate}}">{{ question.questionKey | translate}}</label>
              </div>
              <app-dropdown-box [dropdownBoxId]="'question'+question.questionId"
                                formControlName="{{'question' + question.questionId}}"
                                [options]="question.optionChoiceForUI">
              </app-dropdown-box>
            </div>
            <div class="cell small-12 medium-8" *ngIf="question.questionTypeId === QuestionType.YES_NO">
              <app-yes-no-rating-radio-buttons
                formControlName="{{'question' + question.questionId}}"
                [id]="'question' + question.questionId" [label]="question.questionKey | translate"
                [ngStyle]="{'text-transform': 'none !important'}">
              </app-yes-no-rating-radio-buttons>
            </div>
          </ng-container>
          <ng-container *ngFor="let question of customQuestionsForPosting">
            <div class="cell small-12 medium-8 question" *ngIf="question.questionTypeId === QuestionType.SHORT_TEXT || question.questionTypeId === QuestionType.LONG_TEXT">
              <app-textarea-box
                                [textBoxId]="'question' + question.customQuestionId"
                                [name]="question.description"
                                [labelText]="question.description"
                                [maxLength]="500"
                                [placeholder]="'pre-interview-questions.textarea-max-characters'"
                                [showRemainingCharacters]="true"
                                formControlName="{{'question' + question.customQuestionId}}"
                                [source]=source>
              </app-textarea-box>
            </div>
          </ng-container>
          <div class="cell submit-button-container">
            <button
              id="answers-submit"
              type="submit"
              class="button submit submit-button"
              href="#"
              (click)="submitAnswers()"
              [ngClass]="{
              'aquent-style-button': source == 'gather'
              }"
              [disabled]="submitBtnDisabled"
            >{{"Next" | translate}}</button>
          </div>
          <div class="cell spinner-container">
            <ng-container *ngIf="showSpinner">
              <img src="../../assets/images/spinner.gif"/>
            </ng-container>
          </div>
        </div>
      </form>
      <span data-iframe-height></span>
    </section>
  </div>
</div>
